export { default } from "./PopularItems.jsx";
